// This package polyfills window.locks if it doesn't exist in the browser
import 'navigator.locks';

import type { LockManager } from 'navigator.locks';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-type-assertion -- navigator.locks is not in standard TS lib types; the navigator.locks polyfill ensures it exists at runtime
const lockManager = window?.navigator ? ((window.navigator as any).locks as LockManager) : null;

export default lockManager;
